
import React,{ useEffect } from 'react';
import { BASE_URL } from "../utils/config";
import { useNavigate } from 'react-router-dom';
import '../App.css';
import Sidebar from '../components/sidebar';
import DashBorad from './Dashboard';

const Home = () => {
   const navigate = useNavigate();
 let count = 0
useEffect(()=>{
  if(count === 0){
  fetchlatestUserData()
  count += 1;
}
},[])


const fetchlatestUserData = ()=>{
  let loginuser = JSON.parse(localStorage.getItem("loginData"));
  let userID = loginuser.user_id
  fetch(`${BASE_URL}/getUserbyID/${userID}`, {
    method: "get",
    headers: {
      'Authorization': `Bearer ${loginuser.token}`
    }
  })
  .then((res) => res.json())
  .then((res) => {
      console.log("res", res);
      if (res.success === true) {
         
      
        let userdata = res.userData[0];
        console.log("userdata", userdata);
        if (userdata.role_type === "SuperAdmin") {
          console.log("admin user");
          localStorage.setItem("userdetails", JSON.stringify(userdata));
          localStorage.setItem("roleType", JSON.stringify("SuperAdmin"));
        } else if(userdata.role_type === "Supervisor"){
          console.log("Supervisor");
          localStorage.setItem("userdetails", JSON.stringify(userdata));
     
          localStorage.setItem("roleType", JSON.stringify("Supervisor"));
  
        }
        else if(userdata.role_type === "User"){
          console.log("normal user");
          localStorage.setItem("userdetails", JSON.stringify(userdata));
        
          localStorage.setItem("roleType", JSON.stringify("User"));
       
        } else if(userdata.role_type === "MCXUser"){
          console.log("MCXUser==========");
          localStorage.setItem("userdetails", JSON.stringify(userdata));
        
          localStorage.setItem("roleType", JSON.stringify("MCXUser"));
       
        }
       
      }
      else if(res.status === 403){ 
        setTimeout(()=>{
          localStorage.clear()
           navigate('/login')
        },3000) 
      }
      else if(res.status === 401){
        setTimeout(()=>{
          localStorage.clear()
           navigate('/login')
        },3000) 
      }
  })
}
 
  return(
    <div>


    <Sidebar/>
    {/* <div id="container" className="container"> */}
    {/* <CreateReport/> */}
    <DashBorad/>
    {/* </div> */}
    </div>
  );
};

export default Home;
